import { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { AppRoutes } from './router';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import FloatingCTA from '@/components/feature/FloatingCTA';
import { AuthProvider } from '@/context/AuthContext';

declare const __BASE_PATH__: string;

const AppContent = () => {
  const location = useLocation();
  const isCrm = location.pathname.startsWith('/crm');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      {!isCrm && <Navbar />}
      <AppRoutes />
      {!isCrm && <Footer />}
      {!isCrm && <FloatingCTA />}
    </>
  );
};

const App = () => {
  return (
    <HelmetProvider>
      <BrowserRouter basename={__BASE_PATH__}>
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
};

export default App;
